/**
 * @generated SignedSource<<e0258fe2981f7d40c97f0156ea4f3160>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedMarketTrends_itemSearch$data = {
  readonly pageType: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"getAppliedFilterDisplayName_itemSearch">;
  readonly " $fragmentType": "SbSharedMarketTrends_itemSearch";
};
export type SbSharedMarketTrends_itemSearch$key = {
  readonly " $data"?: SbSharedMarketTrends_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedMarketTrends_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedMarketTrends_itemSearch",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "getAppliedFilterDisplayName_itemSearch",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SearchBrowseParsedParam",
          "kind": "LinkedField",
          "name": "appliedFilters",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "SearchBrowseParsedParamValue",
              "kind": "LinkedField",
              "name": "values",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayName",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pageType",
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "0bf1eef412037fe16686ac4e2f7ef340";

export default node;
